import React from "react";

interface HeaderBtnsBgProps {
  width?: number;
  height?: number;
  className?: string;
}

export const HeaderBtnsBg: React.FC<HeaderBtnsBgProps> = ({
  width = 157,
  height = 60,
  className,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 157 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M157 33.9664H130.593L120.816 17.1587H48.0303L38 1.96643H2"
      stroke="#2A1E54"
      strokeMiterlimit="10"
    />
    <path
      d="M3.8809 59.2586C3.56295 59.5806 3.1579 59.8 2.71695 59.8888C2.276 59.9776 1.81897 59.9319 1.40363 59.7576C0.988291 59.5832 0.633302 59.2879 0.383548 58.9091C0.133793 58.5303 0.000488281 58.085 0.000488281 57.6294C0.000488281 57.1738 0.133793 56.7285 0.383548 56.3497C0.633302 55.9709 0.988291 55.6756 1.40363 55.5012C1.81897 55.3269 2.276 55.2812 2.71695 55.37C3.1579 55.4589 3.56295 55.6782 3.8809 56.0003C4.09207 56.2142 4.25959 56.4682 4.37388 56.7477C4.48817 57.0272 4.54699 57.3268 4.54699 57.6294C4.54699 57.932 4.48817 58.2316 4.37388 58.5111C4.25959 58.7907 4.09207 59.0446 3.8809 59.2586Z"
      fill="#7F5CFF"
    />
    <path
      d="M2.27325 4.60717C3.52873 4.60717 4.5465 3.57582 4.5465 2.30359C4.5465 1.03135 3.52873 0 2.27325 0C1.01777 0 0 1.03135 0 2.30359C0 3.57582 1.01777 4.60717 2.27325 4.60717Z"
      fill="#2A1E54"
    />
    <path
      d="M157 20.9664H130.593L120.816 37.7742H48.0303L38 57.9664H2.5"
      stroke="#2A1E54"
      strokeMiterlimit="10"
    />
  </svg>
);
